import { capitalCase } from "change-case";

export const enumToValueAsKeyOptions = (enumValues) => {
  return enumValues?.map((value) => ({
    label: capitalCase(value),
    value: value,
  }));
};
